import { makeStyles } from "@material-ui/core/styles";
import { theme } from "./theme";
import { pageTitle, subtitleText, link, linkDiscreet, separator } from "./sharedStyles";

export const useStyles = makeStyles(() => ({
  container: {
    fontFamily: theme.fontFamily,
    color: theme.text.primary,
    backgroundColor: theme.colors.white,
    margin: "auto",
    padding: "9px 32px 32px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "1rem",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  toggleWrapper: {
    paddingLeft: "16px",
  },
  notificationArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0.5rem",
  },
  radioOption: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
  },
  radioLabel: {
    fontSize: theme.fontSizes.md,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  headerLinkContainer: {
    display: "flex",
    alignItems: "center",
  },
  toggleContainer: {
    display: "flex", 
    marginLeft: "5rem"
  },
  headerPipe: {
    color: "#B8B8B8",
    fontSize: theme.fontSizes.xl,
    fontWeight: 600,
  },
  standaloneTitle: { ...pageTitle },
  wizardTitle: { ...pageTitle },
  subtitle: { ...subtitleText },
  separator: { ...separator },
  headerLink: {
    ...linkDiscreet,
    fontSize: theme.fontSizes.sm,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  accessLogLink: {
    ...link,
    fontSize: theme.fontSizes.xs,
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  textoCondominioSelecionados: {
    fontWeight: 400,
    fontSize: theme.fontSizes.md,
    color: theme.text.primary,
  }
}));